<template>
	<div class="p-y-16 bg-white d-flex border-bottom" @click="detail(transaksi)">
		<div class="p-r-12" v-if="transaksi.title === 'Transaksi'">
			<img src="../../../assets/icons/arrow-up-right-red.svg" alt="">
		</div>
		<div class="p-r-12" v-else>
			<img src="../../../assets/icons/plus-green.svg" alt="">
		</div>
		<div class="d-flex-between-center align-items-start w-100">
			<div class="d-block">
				<div class="f-semi f-16 f-c-black">
					{{ transaksi.title }}
					<img src="../../../assets/icons/chevron_right_4.svg"
					     style="margin-top: -4px"
					     class="m-l-4"
					     alt=""
					/>
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					{{ transaksi.idtransaksi }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					{{ transaksi.waktu_transaksi_formated }}
				</div>
			</div>
			<div class="d-block text-right" v-if="transaksi.title === 'Transaksi'">
				<div class="f-semi f-16 f-c-red">
					- {{ transaksi.kuota_transaksi | currency }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					Sisa {{ transaksi.saldo | currency }}
				</div>
			</div>
			<div class="d-block text-right" v-else>
				<div class="f-semi f-16 f-c-green">
					+ {{ transaksi.kuota_transaksi | currency }}
				</div>
				<div class="f-regular f-13 f-c-midgrey">
					Saldo menjadi {{ formatRupiah(transaksi.saldo) }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardCustomerGlobalTransaksiPaylink",
	props: {
		transaksi: Object
	},
	methods: {
		detail(transaksi) {
			if (transaksi.tipe === 1) {
				this.$emit("detail", transaksi.idtransaksi)
			}
		}
	}
}
</script>